import { DFPManager } from '@edmunds/react-dfp';
import { refreshGptSlotsV2 } from './gpt-runtime-v2';

function getIsReactAdsEnabled() {
  return Boolean(window?.EDM?.Venom?.reactAds);
}

export function refreshGptSlots(...slotIds) {
  if (typeof window === 'undefined') {
    return;
  }

  if (!getIsReactAdsEnabled()) {
    DFPManager.refresh(...slotIds);
    return;
  }

  refreshGptSlotsV2(...slotIds);
}
